import {isMarkActive} from "../../../utils/isMarkActive";
import {schema} from "../../config/schema";
import {toggleMark} from "prosemirror-commands";

export const isHighlightMarkActive = isMarkActive(schema.marks.highlight);

export const toggleHighlightMark = toggleMark(schema.marks.highlight);
